export default __webpack_public_path__ + "ff9ecd68ad1019fa134456df0b206b19.svg";